"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ButtonsGroup["default"];
  }
});
var _ButtonsGroup = _interopRequireDefault(require("./ButtonsGroup"));